// import React, { useEffect, useState } from "react";
// import { useAppDispatch, useAppSelector } from "../../utils/redux/hooks";
// import { addisLoading, addnotifications } from "../../utils/redux/mainSlice";
// import {
//   addAgent,
//   downloadMailingList,
//   downloadWaitingList,
//   getNotifications,
//   sendPushtoUserbyID,
// } from "../../utils/apis/func";
// import { RootState } from "../../utils/redux/store";
// import { FaAngleDown, FaAngleUp } from "react-icons/fa";
// import { Dropdown } from "flowbite-react";
// import { toast } from "react-toastify";
// import { exportToCsv } from "../helpers/walletTabs/TempTwoTabs/allOrders";

// const NotificationContent = () => {
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [selectedRecipient, setSelectedRecipient] = useState("All Users");

//   const notifications = useAppSelector(
//     (store: RootState) => store.user.notifications
//   );

//   const dispatch = useAppDispatch();

//   //if notification to single User

//   useEffect(() => {
//     const fetchNotifications = async () => {
//       dispatch(addisLoading(true));
//       const res: any = await getNotifications("");

//       if (res?.status === 200 || res?.status === 201) {
//         dispatch(addnotifications(res?.data?.data));
//       }

//       dispatch(addisLoading(false));
//     };

//     fetchNotifications();
//   }, [dispatch]);

//   const toggleDropdown = () => {
//     setIsDropdownOpen((prevState) => !prevState);
//   };

//   const handleRecipientSelect = (recipient: string) => {
//     setSelectedRecipient(recipient);
//     setIsDropdownOpen(false);
//   };

//   const dropdownOptions = [
//     "All Users",
//     "All Customers",
//     "All Freelancers",
//     "All Business",
//     "Specific User",
//   ];

//   const customers = useAppSelector((store: RootState) => store.user.customers);

//   const [userSelected, setuserSelected] = useState(
//     (customers as any)[0]?.id || (customers as any)[0]?._id
//   );
//   console.log(userSelected);

//   const [notifData, setnotifData] = useState({
//     title: "",
//     body: "",
//   });

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, value } = e.target;
//     setnotifData({
//       ...notifData,
//       [name]: value,
//     });
//   };
//   const [isLoading, setisLoading] = useState(false);
//   const handleSendNotif = async () => {
//     console.log(notifData);
//     setisLoading(true);
//     // dispatch(addisLoading(true));
//     const res: any = await sendPushtoUserbyID(userSelected, notifData);
//     console.log(res);
//     if (res?.status === 200 || res?.status === 201) {
//       toast("Notif Sent Successfully", {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "light",
//       });
//     }
//     // dispatch(addisLoading(false));
//     setisLoading(false);
//   };

//   const handleDownload = (data: string, fileName: string) => {
//     const blob = new Blob([data], { type: "text/csv;charset=utf-8" });
//     const encodedUri = URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", fileName);

//     document.body.appendChild(link);

//     link.click();

//     URL.revokeObjectURL(encodedUri);
//     link.remove();
//   };
//   const handleWaitingListDownload = async () => {
//     const response: any = await downloadWaitingList("", "");

//     if (response?.status === 200) {
//       handleDownload(response?.data, "waiting=list.csv");
//     }
//   };

//   const handleMailingListDownload = async () => {
//     const response: any = await downloadMailingList("", "");

//     if (response?.status === 200) {
//       handleDownload(response?.data, "mailing-list.csv");
//     }
//   };
//   return (
//     <>
//     <div className=" h-screen">
//       <div className="flex gap-4 px-6">
//         <p className="text-[#88087B] font-roboto text-3xl font-medium leading-normal">
//           Notification
//         </p>
//         <span className="border border-r-[#000]"></span>
//       </div>
//       <div className="px-3">
//         <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b border-[#000] w-fit px-4">
//           Send Notification
//         </p>
//       </div>
//       <section className="flex flex-col lg:flex-row lg:4/5 w-full xl:w-3/5 gap-16 px-3 lg:px-6 mt-6">
//         <div className="flex flex-col gap-7 w-full lg:w-3/5 font-roboto text-sm font-normal leading-normal">
//           <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               Notification Type:{" "}
//               <input
//                 className="ml-4 flex-grow bg-[#fff] rounded-lg px-1"
//                 value={"Push Notification"}
//               ></input>
//             </p>
//           </div>
//           {/* <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               Recipient:{" "}
//               <span
//                 className="ml-4 flex flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between cursor-pointer"
//                 onClick={toggleDropdown}
//               >
//                 {selectedRecipient}{" "}
//                 {isDropdownOpen ? (
//                   <FaAngleUp size={20} />
//                 ) : (
//                   <FaAngleDown size={20} />
//                 )}
//               </span>
//             </p>
//           </div> */}
//           {/* {isDropdownOpen && (
//             <div className="absolute top-[15.6rem] lg:top-[17.4rem] left-[6.25rem] lg:left-96 z-50 border border-[#88087B] bg-[#fff] w-2/3 lg:w-1/5 text-left px-6 py-2 rounded-md">
//               <ul>
//                 {dropdownOptions.map((option) => (
//                   <li
//                     className="cursor-pointer text-sm font-semibold"
//                     key={option}
//                     onClick={() => handleRecipientSelect(option)}
//                   >
//                     {option}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )} */}

//           <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm flex gap-2">
//             <label htmlFor="notifReceiver">Recipient: </label>

//             <select
//               name="notifReceiver"
//               id="notifReceiver"
//               className="w-full"
//               onChange={(e) => handleRecipientSelect((e as any).target.value)}
//             >
//               {dropdownOptions.map((item, index) => {
//                 return (
//                   <option value={item} key={index}>
//                     {item}
//                   </option>
//                 );
//               })}
//             </select>
//           </div>

//           {selectedRecipient.toLowerCase() === "specific user" && (
//             <>
//               <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm flex gap-2">
//                 <label htmlFor="selectUSer" className="w-max whitespace-nowrap">Select User: </label>
//                 <select
//                   name="selectedUser"
//                   id="selectUSer"
//                   onChange={(e) => setuserSelected(e.target.value)}
//                   className="w-full"
//                 >
//                   {customers?.map((item, index) => (
//                     <option value={item?._id || item?.id}>
//                       {item?.firstName} {item?.lastName}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               {/*
//               <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
//                 <p className="flex items-center">
//                   Select User:
//                   <Dropdown
//                     dismissOnClick={false}
//                     className="flex-1 bg-white"
//                     size="xl"
//                     style={{
//                       width: "100%",
//                       border: "none",
//                       background: "white",
//                     }}
//                     label="User"
//                   >
//                     {customers?.map((item) => {
//                       return (
//                         <p
//                           onClick={() => setuserSelected(item?._id || item?.id)}
//                           className="py-2 px-4"
//                         >
//                           {item?.firstName} {item?.lastName}
//                         </p>
//                       );
//                     })}
//                   </Dropdown>
//                 </p>
//               </div> */}
//             </>
//           )}

//           <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
//             <p className="flex items-center">
//               Title:{" "}
//               <input
//                 className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
//                 type="text"
//                 id="address"
//                 name="address"
//                 onChange={handleChange}
//               ></input>
//             </p>
//           </div>
//           <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
//             <p className="flex items-start">
//               {" "}
//               Message:{" "}
//               <textarea
//                 className="ml-5 flex-grow bg-[#fff] rounded-2xl px-1 resize-none"
//                 rows={5}
//                 onChange={(e) => {
//                   const { name, value }: any = e.target;
//                   setnotifData({
//                     ...notifData,
//                     [name]: value,
//                   });
//                 }}
//                 name="body"
//               />
//             </p>
//           </div>
//           <div className="px-12 w-full flex justify-center items-center lg:block">
//             <button
//               onClick={() => {
//                 if (selectedRecipient === "Specific User") {
//                   handleSendNotif();
//                 }
//               }}
//               className="bg-[#88087B] text-[#FFCD1E] text-center text-shadow font-roboto text-lg font-medium leading-normal w-1/4 rounded-md mt-4 "
//             >
//               Done
//             </button>
//           </div>
//         </div>

//         {/* <div className="flex flex-col lg:justify-items-end sm:justify-center  ">
//           <p>All Users</p>
//           <p>All Customers</p>
//           <p>All Freelancers</p>
//           <p>All Business</p>
//           <p>Specific User</p>
//         </div> */}
//       </section>
//     </div>

// <div className="p-6 flex gap-4">
//   <button
//     className="bg-[#88087B] text-white rounded-lg px-4 py-2"
//     onClick={handleWaitingListDownload}
//   >
//     waiting list
//   </button>
//   <button
//     className="bg-[#88087B] text-white rounded-lg px-4 py-2"
//     onClick={handleMailingListDownload}
//   >
//     mailing list
//   </button>
// </div>
//     </>
//   );
// }
// export default NotificationContent;

import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/redux/hooks";
import { addisLoading, addnotifications } from "../../utils/redux/mainSlice";
import {
  getNotifications,
  sendPushtoUserbyID,
  downloadWaitingList,
  downloadMailingList,
} from "../../utils/apis/func";
import { RootState } from "../../utils/redux/store";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { Dropdown } from "flowbite-react";
import { toast } from "react-toastify";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
// import Modal from "react-modal";
import UsersModal from "../helpers/referrals/usersModal";

const NotificationContent = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedRecipient, setSelectedRecipient] = useState("All Users");
  const notifications = useAppSelector(
    (store: RootState) => store.user.notifications
  );
  const customers = useAppSelector((store: RootState) => store.user.customers);
  const providers = useAppSelector((store: RootState) => store.user.providers);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchNotifications = async () => {
      dispatch(addisLoading(true));
      const res: any = await getNotifications("");
      if (res?.status === 200 || res?.status === 201) {
        dispatch(addnotifications(res?.data?.data));
      }
      dispatch(addisLoading(false));
    };
    fetchNotifications();
  }, [dispatch]);

  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const handleRecipientSelect = (recipient: string) => {
    setSelectedRecipient(recipient);
    setIsDropdownOpen(false);
  };

  const dropdownOptions = [
    "All Users",
    "All Customers",
    "All Freelancers",
    "All Business",
    "Specific User",
  ];

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    body: Yup.string().required("Message is required"),
    // user: Yup.string().when("recipient", {
    //   is: (val: string) => val === "Specific User",
    //   then: Yup.string().required("User is required"),
    // }),
    user: Yup.string(),
    isVerified: Yup.string().notRequired(),
  });

  // const handleSendNotif = async (values: any) => {
  //   // setSubmitting(true);
  //   const res: any = await sendPushtoUserbyID(values.user, {
  //     title: values.title,
  //     body: values.body,
  //   });
  //   // setSubmitting(false);
  //   if (res?.status === 200 || res?.status === 201) {
  //     toast("Notification Sent Successfully", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "light",
  //     });
  //   }
  // };

  const [loading, setloading] = useState(false);

  const handleSendAllNotif = async (values: any) => {
    setloading(true);
    let payload: any = {
      // "id": "", // Specific user ID
      // "accountType": "", // Account type to filter users
      data: {
        title: values.title,
        body: values.body,
      },
    };
    if (values.recipient === "Specific User") {
      payload.id = values.user;
    }
    if (values.recipient !== "Specific User") {
      if (values.recipient === "All Customers") {
        payload.accountType = "customer";
      }
      if (values.recipient === "All Freelancers") {
        payload.accountType = "freelancer";
      }
      if (values.recipient === "All Business") {
        payload.accountType = "business";
      }
    }
    if (values.isVerified === 'Verified') {
      payload.isVerified = true
    }
    if (values.isVerified === 'UnVerified') {
      payload.isVerified = false
    }

    // console.log(payload);
    // setloading(false);

    // return;
    const res: any = await sendPushtoUserbyID(payload);
    const opts = {
      position: "top-right" as const,
      autoClose: 8000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light" as const,
    };

    if (res?.status === 200 || res?.status === 201) {
      /* Say what actually happened. This used to celebrate on any 200, so a
         send that reached nobody looked exactly like one that reached
         everybody, and "notifications don't work" could not be told apart from
         "notifications went to people who have not installed the app". */
      const { sent = 0, matched = 0, noToken = 0, failed = 0, error } = res?.data ?? {};

      if (failed > 0) {
        toast.error(
          `Sent to ${sent} of ${matched}. ${failed} failed` +
            (error ? `: ${String(error).slice(0, 140)}` : "."),
          opts
        );
      } else if (sent > 0) {
        toast.success(
          `Sent to ${sent} ${sent === 1 ? "device" : "devices"}` +
            (noToken ? `. ${noToken} had no device registered.` : "."),
          opts
        );
      } else if (noToken > 0) {
        toast.warn(
          `Nobody was notified: ${noToken} matched but ${noToken === 1 ? "has" : "have"} no device registered. They have not signed in to the app, or notifications are off.`,
          opts
        );
      } else {
        toast.warn("Nobody matched, so nothing was sent.", opts);
      }
    } else {
      toast.error(
        res?.error?.message || "Could not send the notification. Nothing was sent.",
        opts
      );
    }
    setloading(false);
  };

  const handleSubmit = (values: any, { setSubmitting }: any) => {
    // if (values.recipient === "Specific User") {
    //   handleSendNotif(values);
    // } else {
    //   handleSendAllNotif(values);
    // }
    handleSendAllNotif(values);
  };

  const handleDownload = (data: string, fileName: string) => {
    const blob = new Blob([data], { type: "text/csv;charset=utf-8" });
    const encodedUri = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName);

    document.body.appendChild(link);

    link.click();

    URL.revokeObjectURL(encodedUri);
    link.remove();
  };

  const handleWaitingListDownload = async () => {
    const response: any = await downloadWaitingList("", "");
    if (response?.status === 200) {
      handleDownload(response?.data, "waiting-list.csv");
    }
  };

  const handleMailingListDownload = async () => {
    const response: any = await downloadMailingList("", "");
    if (response?.status === 200) {
      handleDownload(response?.data, "mailing-list.csv");
    }
  };

  const [showUserModal, setshowUserModal] = useState(false);
  const [selectedUser, setselectedUser]: any = useState();

  return (
    <>
      <div className="h-screen">
        <div className="flex gap-4 px-6">
          <p className="text-[#88087B] font-roboto text-3xl font-medium leading-normal">
            Notification
          </p>
          <span className="border border-r-[#000]"></span>
        </div>
        <div className="px-3">
          <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b border-[#000] w-fit px-4">
            Send Notification
          </p>
        </div>
        <section className="flex flex-col lg:flex-row lg:4/5 w-full xl:w-3/5 gap-16 px-3 lg:px-6 mt-6">
          <Formik
            initialValues={{
              recipient: "All Users",
              user: "",
              title: "",
              body: "",
              isVerified: "none",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSendAllNotif}
          >
            {({ values, isSubmitting, setFieldValue, isValid }) => (
              <Form className="flex flex-col gap-7 w-full lg:w-3/5 font-roboto text-sm font-normal leading-normal">
                <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
                  <p className="flex items-center">
                    Notification Type:
                    <Field
                      type="text"
                      name="notificationType"
                      className="ml-4 flex-grow bg-[#fff] rounded-lg px-1"
                      value="Push Notification"
                      readOnly
                    />
                  </p>
                </div>
                <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm flex gap-2">
                  <label htmlFor="recipient">Recipient:</label>
                  <Field
                    as="select"
                    name="recipient"
                    className="w-full"
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      setFieldValue("recipient", e.target.value);
                      handleRecipientSelect(e.target.value);
                    }}
                  >
                    {dropdownOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </Field>
                </div>

                {(values.recipient === "All Freelancers" ||
                  values.recipient === "All Business") && (
                  <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm flex gap-2">
                    <label htmlFor="recipient">isVerified:</label>
                    <Field
                      as="select"
                      name="isVerified"
                      className="w-full"
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        setFieldValue("isVerified", e.target.value);
                        handleRecipientSelect(e.target.value);
                      }}
                    >
                      <option key={"none"} value={"none"}>
                        none
                      </option>
                      <option key={"Verified"} value={"Verified"}>
                        Verified
                      </option>
                      <option key={"UnVerified"} value={"UnVerified"}>
                        Unverified
                      </option>
                    </Field>
                  </div>
                )}

                {values.recipient === "Specific User" && (
                  <>
                    <div
                      onClick={() => {
                        setshowUserModal(true);
                      }}
                      className="bg-[#8E8E93] border border-[#88087B] rounded-sm flex gap-2"
                    >
                      <label htmlFor="user" className="w-max whitespace-nowrap">
                        Select User:
                      </label>
                      {/* {values.user} */}
                      {selectedUser?.firstName} {selectedUser?.lastName}
                    </div>
                    <UsersModal
                      isOpen={showUserModal}
                      onClose={() => {
                        setshowUserModal(false);
                        setshowUserModal(false);
                        console.log("clicked", showUserModal);
                      }}
                      onSelect={(value: any) => {
                        setFieldValue("user", value?._id ?? value?.id);
                        setselectedUser(value);
                        setshowUserModal(false);
                        // console.log(selectedUser);
                      }}
                      id={""}
                      setFieldValue={setFieldValue}
                      customers={customers}
                      providers={providers}
                    />
                    <Field type="hidden" name="user" />
                    <ErrorMessage
                      name="user"
                      component="div"
                      className="text-red-500"
                    />
                    {/* <div
                      onClick={() => {
                        // setshowUserModal(true);
                      }}
                      className="bg-[#8E8E93] border border-[#88087B] rounded-sm flex gap-2"
                    >
                      <label htmlFor="user" className="w-max whitespace-nowrap">
                        Select User:
                      </label>
                      <UserSelectModal
                      customers={customers}
                      providers={providers}
                      setFieldValue={setFieldValue}
                    />
 
                      <Field as="select" name="user" className="w-full">
                      {[...customers, ...providers]?.map((item) => (
                        <option
                          key={item._id || item.id}
                          value={item._id || item.id}
                        >
                          {item.firstName} {item.lastName}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name="user"
                      component="div"
                      className="text-red-500"
                    />
                    </div> */}
                  </>
                )}

                <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
                  <p className="flex items-center">
                    Title:
                    <Field
                      type="text"
                      name="title"
                      className="ml-4 flex h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    />
                  </p>
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-red-500"
                  />
                </div>
                <div className="bg-[#8E8E93] border border-[#88087B] rounded-sm">
                  <p className="flex items-start">
                    Message:
                    <Field
                      as="textarea"
                      name="body"
                      className="ml-5 flex-grow bg-[#fff] rounded-2xl px-1 resize-none"
                      rows={5}
                    />
                  </p>
                  <ErrorMessage
                    name="body"
                    component="div"
                    className="text-red-500"
                  />
                </div>
                <div className="px-12 w-full flex justify-center items-center lg:block">
                  <button
                    type="submit"
                    disabled={!isValid || loading}
                    className={`${
                      loading ? "bg-[#88087B1A]" : "bg-[#88087B]"
                    } text-[#FFCD1E] text-center text-shadow font-roboto text-lg font-medium leading-normal sm:w-[50%] lg:w-[100%] py-2 rounded-md mt-4`}
                  >
                    {loading ? "Sending..." : "Send"}
                  </button>

                  {/* <div
                    className="px-4 py-2 bg-[#88087B]"
                    onClick={() => {
                      console.log("hello--", isValid);
                      // handleSendAllNotif(values);
                    }}
                  >
                    Hello world
                  </div> */}
                </div>
              </Form>
            )}
          </Formik>
        </section>
      </div>
      <div className="p-6 flex gap-4">
        <button
          className="bg-[#88087B] text-white rounded-lg px-4 py-2"
          onClick={handleWaitingListDownload}
        >
          waiting list
        </button>
        <button
          className="bg-[#88087B] text-white rounded-lg px-4 py-2"
          onClick={handleMailingListDownload}
        >
          mailing list
        </button>
      </div>
    </>
  );
};

// const UserSelectModal = ({ customers, providers, setFieldValue }: any) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   const users = [...customers, ...providers].filter((user) =>
//     `${user.firstName} ${user.lastName}`
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   const openModal = () => setIsOpen(true);
//   const closeModal = () => setIsOpen(false);

//   return (
//     <div>
//       <button type="button" onClick={openModal} className="btn btn-primary">
//         Select User
//       </button>
//       <Modal
//         isOpen={isOpen}
//         onRequestClose={closeModal}
//         contentLabel="Select User"
//       >
//         <h2>Select User</h2>
//         <input
//           type="text"
//           placeholder="Search..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           className="input input-bordered w-full rounded-lg input-md"
//         />
//         <ul className="list-none max-h-60 overflow-y-auto mt-4">
//           {users.map((user) => (
//             <li
//               key={user._id || user.id}
//               onClick={() => {
//                 setFieldValue("user", user._id || user.id);
//                 closeModal();
//               }}
//               className="cursor-pointer p-2 hover:bg-gray-200"
//             >
//               {user.firstName} {user.lastName}
//             </li>
//           ))}
//         </ul>
//         <button onClick={closeModal} className="btn btn-secondary mt-4">
//           Close
//         </button>
//       </Modal>
//     </div>
//   );
// };

export default NotificationContent;
